class $61010cb15f95c70e$export$baf26146a414f24a {
    constructor(gridX, gridY){
        this.size = 3;
        this.gridX = gridX;
        this.gridY = gridY;
        this.displayX = 0;
        this.displayY = 0;
        this.visible = true;
    }
    clone() {
        const newPoint = new $61010cb15f95c70e$export$baf26146a414f24a(this.gridX, this.gridY);
        newPoint.displayX = this.displayX;
        newPoint.displayY = this.displayY;
        return newPoint;
    }
    render(ctx) {
        if (this.visible) {
            ctx.fillStyle = "#ccc";
            ctx.fillRect(this.displayX, this.displayY, this.size, this.size);
        }
    }
}


class $59ecd5dd974a5d4c$export$2bbdffc3094bc005 {
    constructor(pointDistance, displayWidth, displayHeight){
        this.pointDistance = pointDistance;
        this.resize(displayWidth, displayHeight);
    }
    resize(displayWidth, displayHeight) {
        this.points = [];
        this.horizontalPointCount = Math.ceil(displayWidth / this.pointDistance);
        this.verticalPointCount = Math.ceil(displayHeight / this.pointDistance);
        this.xPadding = (displayWidth - (this.horizontalPointCount - 1) * this.pointDistance) / 2;
        this.yPadding = (displayHeight - (this.verticalPointCount - 1) * this.pointDistance) / 2;
        for(let x = 0; x < this.horizontalPointCount; x++)for(let y = 0; y < this.verticalPointCount; y++)this.points.push(new (0, $61010cb15f95c70e$export$baf26146a414f24a)(x, y));
    }
    update() {
        this.points.forEach((point)=>{
            point.displayX = point.gridX * this.pointDistance + this.xPadding;
            point.displayY = point.gridY * this.pointDistance + this.yPadding;
        });
    }
    render(ctx) {
        this.points.forEach((point)=>{
            point.render(ctx);
        });
    }
    selectVisibleAdjacentPoints() {
        const firstPoint = this.shuffleArray(this.points.filter((point)=>point.visible))[0];
        if (firstPoint == null) return [
            null,
            null
        ];
        const secondPoint = this.shuffleArray(this.selectVisibleCardinalPoints(firstPoint))[0];
        return [
            firstPoint,
            secondPoint
        ];
    }
    selectVisibleCardinalPoints({ gridX: gridX, gridY: gridY }) {
        return [
            this.findPoint(gridX + 1, gridY),
            this.findPoint(gridX - 1, gridY),
            this.findPoint(gridX, gridY + 1),
            this.findPoint(gridX, gridY - 1)
        ].filter((point)=>point != null).filter((point)=>point.visible);
    }
    findPoint(gridX, gridY) {
        return this.points.find((point)=>point.gridX === gridX && point.gridY === gridY);
    }
    // taken from https://stackoverflow.com/a/6274381/1950372
    shuffleArray(a) {
        for(let i = a.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [
                a[j],
                a[i]
            ];
        }
        return a;
    }
}


class $3f0e2282ff1587bd$export$90de0cfb0ccee174 {
    constructor(firstPoint, secondPoint, callback){
        this.frameDuration = 60; // in frames
        this.frame = 0;
        this.isRunning = true;
        this.callback = callback;
        this.callbackCalled = false;
        this.firstPoint = firstPoint.clone();
        this.secondPoint = secondPoint.clone();
        this.originalDisplayCoords = {
            firstPoint: {
                displayX: firstPoint.displayX,
                displayY: firstPoint.displayY
            },
            secondPoint: {
                displayX: secondPoint.displayX,
                displayY: secondPoint.displayY
            }
        };
        this.xDistance = firstPoint.displayX - secondPoint.displayX;
        this.yDistance = firstPoint.displayY - secondPoint.displayY;
    }
    ease(t, b, c, d) {
        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    }
    update() {
        this.frame += 1;
        if (this.frame > this.frameDuration) {
            this.isRunning = false;
            if (!this.callbackCalled) {
                this.callback(this);
                this.callbackCalled = true;
            }
        } else {
            this.firstPoint.displayX = this.ease(this.frame, this.originalDisplayCoords.firstPoint.displayX, -this.xDistance, this.frameDuration);
            this.firstPoint.displayY = this.ease(this.frame, this.originalDisplayCoords.firstPoint.displayY, -this.yDistance, this.frameDuration);
            this.secondPoint.displayX = this.ease(this.frame, this.originalDisplayCoords.secondPoint.displayX, this.xDistance, this.frameDuration);
            this.secondPoint.displayY = this.ease(this.frame, this.originalDisplayCoords.secondPoint.displayY, this.yDistance, this.frameDuration);
        }
    }
    render(ctx) {
        if (this.isRunning) {
            this.firstPoint.render(ctx);
            this.secondPoint.render(ctx);
        }
    }
}


class $1dce007107cac56e$export$a9157d44f8740852 {
    constructor(){
        this.backgroundCanvas = document.querySelector("#background-canvas");
        this.ctx = this.backgroundCanvas.getContext("2d");
        this.pointGrid = new (0, $59ecd5dd974a5d4c$export$2bbdffc3094bc005)(100, this.ctx.canvas.clientWidth, this.ctx.canvas.clientHeight);
        this.pointSwapAnimations = [];
    }
    start() {
        this.addResizeListener();
        this.resize();
        this.startSpawnLoop();
        requestAnimationFrame(()=>this.mainLoop());
    }
    addResizeListener() {
        window.addEventListener("resize", this.resize);
    }
    resize() {
        const displayWidth = window.innerWidth;
        const displayHeight = window.innerHeight;
        this.backgroundCanvas.width = displayWidth;
        this.backgroundCanvas.height = displayHeight;
        this.pointGrid.resize(displayWidth, displayHeight);
    }
    startSpawnLoop() {
        setInterval(()=>{
            if (this.pointSwapAnimations.length >= 5) return;
            const [firstPoint, secondPoint] = this.pointGrid.selectVisibleAdjacentPoints();
            if (firstPoint == null || secondPoint == null) return;
            firstPoint.visible = false;
            secondPoint.visible = false;
            this.pointSwapAnimations.push(new (0, $3f0e2282ff1587bd$export$90de0cfb0ccee174)(firstPoint, secondPoint, (animation)=>{
                firstPoint.visible = true;
                secondPoint.visible = true;
                this.pointSwapAnimations.splice(this.pointSwapAnimations.indexOf(animation), 1);
            }));
        }, 500);
    }
    mainLoop() {
        this.update();
        this.render();
        requestAnimationFrame(()=>this.mainLoop());
    }
    update() {
        this.pointGrid.update();
        this.pointSwapAnimations.forEach((pointSwapAnimation)=>pointSwapAnimation.update());
    }
    render() {
        this.clear();
        this.pointGrid.render(this.ctx);
        this.pointSwapAnimations.forEach((pointSwapAnimation)=>pointSwapAnimation.render(this.ctx));
    }
    clear() {
        this.ctx.fillStyle = "#fff";
        this.ctx.fillRect(0, 0, this.ctx.canvas.clientWidth, this.ctx.canvas.clientHeight);
    }
}


class $925fc86b1b994db2$export$fbfa980782cb979a {
    print() {
        console.log(`
Thanks for checking out my website!

You can contact me at billnreed@gmail.com if you'd like to get in touch.
    `);
    }
}


if (document.readyState === "complete" || document.readyState === "interactive") $2d8bd5fc659707cd$var$onReady();
else document.addEventListener("DOMContentLoaded", $2d8bd5fc659707cd$var$onReady);
function $2d8bd5fc659707cd$var$onReady() {
    const pointGridBackground = new (0, $1dce007107cac56e$export$a9157d44f8740852)();
    pointGridBackground.start();
    const consoleMessage = new (0, $925fc86b1b994db2$export$fbfa980782cb979a)();
    consoleMessage.print();
}


//# sourceMappingURL=index.620cad5f.js.map
